﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿﻿<template>
  <div>
    <h2>盈利计算</h2>

    <!-- 日期范围 + 盈亏汇总 -->
    <div class="filter-bar">
      <el-date-picker
        v-model="dateRange"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="YYYY-MM-DD"
        :clearable="false"
        style="width: 360px;"
        @change="handleDateChange"
      ></el-date-picker>

      <div v-if="summary" class="profit-card" :class="summary.total_profit >= 0 ? 'profit' : 'loss'">
        <span class="label">{{ summary.total_profit >= 0 ? '今日盈利' : '今日亏损' }}</span>
        <span class="value">{{ Math.abs(summary.total_profit).toFixed(2) }}</span>
      </div>
    </div>

    <!-- 表格 -->
    <el-card class="box-card" v-loading="loadingData">
      <el-table :data="profitData" stripe>
        <el-table-column label="商品名称" prop="product_name"></el-table-column>
        <el-table-column label="销售价格" prop="sell_price"></el-table-column>
        <el-table-column label="数量" prop="transaction_quantity"></el-table-column>
        <el-table-column label="卖出成本" prop="cost_price"></el-table-column>
        <el-table-column label="盈亏" prop="profit_loss">
          <template #default="{ row }">
            <span :style="{ color: parseFloat(row.profit_loss) >= 0 ? '#f56c6c' : '#67c23a' }">
              {{ parseFloat(row.profit_loss).toFixed(2) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="出货日期" prop="transaction_date">
          <template #default="{ row }">
            {{ formatDate(row.transaction_date) }}
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 分页 -->
    <el-pagination
      v-if="total > 0"
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      :page-sizes="[20, 50, 100, 200]"
      layout="total, sizes, prev, pager, next, jumper"
      @current-change="handlePageChange"
      @size-change="handleSizeChange"
      style="margin-top: 20px; text-align: center;"
    ></el-pagination>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import API_BASE from '@/api';
import { ElMessage } from 'element-plus';
import dayjs from 'dayjs';

const profitData = ref([]);      // 当前页明细
const total = ref(0);             // 总条数
const currentPage = ref(1);
const pageSize = ref(50);
const dateRange = ref([
  dayjs().format('YYYY-MM-DD'),
  dayjs().format('YYYY-MM-DD')
]);
const summary = ref(null);        // 后端返回的汇总
const loadingData = ref(false);

const formatDate = (date) => {
  return dayjs(date).format('YYYY-MM-DD HH:mm:ss');
};

const getProfitData = async () => {
  loadingData.value = true;
  try {
    const [start, end] = dateRange.value;
    const response = await axios.get(`${API_BASE}/api/profit`, {
      params: { start, end, page: currentPage.value, pageSize: pageSize.value }
    });
    if (response.data.success) {
      profitData.value = response.data.data;
      total.value = response.data.total;
      summary.value = response.data.summary;
    } else {
      ElMessage.error('盈利数据加载失败：' + response.data.message);
    }
  } catch (error) {
    ElMessage.error('请求出错：' + error.message);
  } finally {
    loadingData.value = false;
  }
};

onMounted(() => {
  getProfitData();
});

const handleDateChange = () => {
  currentPage.value = 1;
  getProfitData();
};

const handlePageChange = (page) => {
  currentPage.value = page;
  getProfitData();
};

const handleSizeChange = (size) => {
  pageSize.value = size;
  currentPage.value = 1;
  getProfitData();
};
</script>

<style scoped>
h2 {
  margin-bottom: 20px;
  font-size: 24px;
}

.filter-bar {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;
}

.profit-card {
  background: #f5f7fa;
  padding: 12px 24px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  min-width: 140px;
  border-left: 4px solid #909399;
}

.profit-card .label {
  font-size: 13px;
  color: #606266;
}

.profit-card .value {
  font-size: 28px;
  font-weight: 700;
  margin-top: 4px;
  font-family: 'DIN', 'Helvetica Neue', sans-serif;
}

/* 盈利 = 红色 */
.profit-card.profit {
  border-left-color: #f56c6c;
  background: #fef0f0;
}
.profit-card.profit .value {
  color: #f56c6c;
}

/* 亏损 = 绿色 */
.profit-card.loss {
  border-left-color: #67c23a;
  background: #f0f9eb;
}
.profit-card.loss .value {
  color: #67c23a;
}

.box-card {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  padding: 20px;
}
</style>
